/**
 * 通讯协议层
 * @type {lookup}
 */
// import _ from 'lodash';
// import CONFIG from '../config';
import platform from '../util/platform';
// import channel, { SerialPort } from './hardware/native/index';

// const CONNECT_URL = CONFIG.socket.url;
let channel;
let SerialPort;
if(platform.isChromeOS){
    let chrome = require('./hardware/chrome/index').default();
    channel = chrome.channel;
    SerialPort = chrome.SerialPort;
}else{
    let native = require('./hardware/native/index').default();
    channel = native.channel;
    SerialPort = native.SerialPort;
}
/* channel = ChromeCommunication().channel;
SerialPort = ChromeCommunication().SerialPort; */
class ConnectService {

    constructor() {
        this.ports = {};
        this.serviceChannel = channel;
    }

    /**
     *
     *
     * @param {string} type 连接类型，取值 [serialport | ble | hid | wifi]
     * @param {string} connectionId 表示唯一连接的id，由connect返回
     * @param {function} listener 数据监听函数
     * @memberof ConnectService
     */
    addDataListener(type, connectionId, listener) {
        // this.dataListerners[`${type}.${connectionId}`] = listener;
        let port = this.ports[connectionId];
        if (port) {
            port.on('data', (data) => {
                listener(data);
            });
        } else {
            console.error(`Service.connect cannot add data listener to  ${type} ${connectionId}`);
        }
    }

    /**
     *
     *
     * @param {string} type 连接类型，取值 [serialport | ble | hid | wifi]
     * @param {string} connectionId 表示唯一连接的id，由connect返回
     * @param {*} listener 错误监听函数
     * @memberof ConnectService
     */
    addErrorListener(type, connectionId, listener) {
        // this.errorListeners[`${type}.${connectionId}`] = listener;
        let port = this.ports[connectionId];
        if (port) {
            port.on('disconnect', (error, isBroken) => {
                listener(error, isBroken);
            });
            port.on('error', (error, isBroken) => {
                listener(error, isBroken);
            });
        } else {
            console.error(`Service.connect cannot add error listener to  ${type} ${connectionId}`);
        }
    }

    /**
     *
     *
     * @static
     * @returns ConnectService
     * @memberof ConnectService
     */
    static getInstance() {
        if (!ConnectService.instance) {
            ConnectService.instance = new ConnectService();
        }
        return ConnectService.instance;
    }

    /**
     * 连接
     * @param {string} type 连接类型，取值 [serialport | ble | hid | wifi]
     * @param {*} device  设备信息 {comName:XXXX, channel:1}
     * @param {function} callback 回调函数，格式function (err) {}
     */
    connect(type, device, callback) {
        console.info('begin connect device ', type, device);
        let connectionId = `${type}.${device.comName}`;

        this.ports[connectionId] = new SerialPort(device.comName, { connectType: type, ...device });
        this.ports[connectionId].open((err) => {
            if (err) {
                console.log('connect error ', err, type, device);
                callback(err);
            } else {
                console.log('connect ok ', type, device);
                callback(null, {
                    comName: device.comName,
                    type,
                    connectionId,
                    rawPort: this.ports[connectionId],
                });
            }
        });
    }

    /**
     *
     *
     * @param {string} type  连接类型，取值 [serialport | ble | hid | wifi]
     * @param {string} connectionId 表示唯一连接的id，由connect返回
     * @param {function} callback 断开连接回调，格式function (err, connectionInfo) {}
     * @memberof ConnectService
     */
    disconnect(type, connectionId, callback) {
        let port = this.ports[connectionId];
        this.ports[connectionId] = null;
        if (port) {
            port.close((err) => {
                if (err) {
                    if (callback) {
                        callback(err, null);
                    }
                } else {
                    if (callback) {
                        callback(null, {
                            comName: connectionId,
                            connectionId,
                        });
                    }
                }

            });
        } else {
            if (callback) {
                callback(null, {
                    comName: connectionId,
                    connectionId,
                });
            }
        }
    }

    /**
     * 发现设备列表
     * @param <string> type 连接类型，取值 [serialport | ble | hid | wifi]
     * @param <function> callback 回调，function(err, ports) {}, port为数组
     */
    discovery(type, callback) {
        console.info('begin discovery', type);
        SerialPort.list(type, (err, ports) => {
            console.info('discovered device ', ports);
            callback(err, ports);
        });
    }

    /**
     *
     *
     * @param {string} type 连接类型，取值 [serialport | ble | hid | wifi]
     * @param {string} connectionId 连接id，表示一次连接
     * @param {array} data 待发送的数据
     * @param {function} callback 发送数据回调，暂时没太多意义
     * @memberof ConnectService
     */
    send(type, connectionId, data, callback) {
        let port = this.ports[connectionId];
        if (port) {
            port.write(data, 'utf8', (err) => {
                callback(err, {});
            });
        } else {
            callback(null, {});
        }
    }

    isInstall() {
        return channel.getChannelConnected();
    }
}

export default ConnectService.getInstance();
